/* eslint-disable max-len */
export default {
  header: {
    navigation: {
      home: 'Home',
      // distribution: 'Distribution',
      // distributionEvent: 'Distribution event',
      // whitepapers: 'Whitepapers',
      downloads: 'Downloads',
      twitter: 'Twitter',
      wallet: 'Wallet',
      explorer: 'Explorer',
      ecosystem: 'Ecosystem',
      skyminer: 'Skyminer',
      hardware: 'Hardware',
      blog: 'Blog',
      // buy: 'Buy Skycoin',
      telegram: 'Telegram',
      discord: 'Discord',
      getWallet: 'Buy Skycoin',
      jobs: 'Jobs',
      ecosystem_overview: 'Overview',
      skywire: 'Skywire',
      skywallet: 'Skywallet',
      obelisk: 'Obelisk',
      fiber: 'Fiber',
      cx: 'CX',
      cxo: 'CXO',
      other: 'Other',
      pressreleases: 'Press Releases',
      gallery: 'Gallery',
      events: 'Events',
      explorerApi: 'Explorer API',
      merchandise: 'Merchandise store',
      hardwareStore: 'Hardware store',
      roadmap: 'Roadmap',
      skywallethdk: 'Skywallet HDK',
      whitepaper: 'Whitepapers',
    },
  },
  footer: {
    rightsReserved: 'All rights reserved',
    getStarted: 'Get started',
  },
  // footer: {
  //   bounty: 'Bounty Channel',
  //   getStarted: 'Get started',
  //   explore: 'Explore',
  //   community: 'Community',
  //   wallet: 'Get Wallet',
  //   buy: 'Buy Skycoin',
  //   infographics: 'Infographics',
  //   whitepapers: 'Whitepapers',
  //   blockchain: 'Blockchain Explorer',
  //   distribution: 'Distribution',
  //   blog: 'Blog',
  //   twitter: 'Twitter',
  //   reddit: 'Reddit',
  //   github: 'Github',
  //   telegram: 'Telegram',
  //   slack: 'Slack',
  //   roadmap: 'Roadmap',
  //   skyMessenger: 'Sky-Messenger',
  //   cxPlayground: 'CX Playground',
  //   team: 'Team',
  //   subscribe: 'Mailing List',
  //   market: 'Markets',
  //   jobs: 'Jobs',
  //   bitcoinTalk: 'Bitcointalk ANN',
  //   instagram: 'Instagram',
  //   facebook: 'Facebook',
  //   discord: 'Discord',
  //   youtube: 'Youtube',
  // },
  // buyBanner: {
  //   lead: 'Existing Skycoins are available separately on the following exchanges',
  // },
  // buy: {
  //   heading: 'Choose your preferred exchange to buy Skycoin',
  //   c2cx: 'Buy on C2CX',
  //   cryptopia: 'Buy on Cryptopia',
  //   distributionEvent: 'Distribution event',
  // },
  notFound: {
    404: '404',
    message:
      "Whoops! Looks like you're lost </br> This page does not exist anymore or has been moved to a new URL",
    title: 'Page not found',
    heading: 'Page not found',
    home: 'Home page',
  },
  // architectureOverview: {
  //   title: 'Architecture overview',
  //   description: 'Architecture overview - components which make up the Skycoin ecosystem',
  //   heading: 'Architecture overview',
  // },
  getStarted: {
    heading: 'Get Started with Skycoin',
    paragraph:
      'True decentralization means no government can censor Skywire, no corporate interest can stop it.<br/><br/>The internet began as a community of people wanting to share information — the time has come to bring back that vision of the internet using a cryptocurrency that truly fulfills Satoshi’s vision of a decentralized cryptocurrency with Skycoin.</p>',
    buy: 'Buy Skycoin',
    wallet: 'Get Wallet',
  },
  newsletter: {
    heading: 'Sign up to receive updates',
    button: 'Sign up',
    input: 'Enter Your Email',
    skyminerOption: "I'm Interested in a Skywire Miner",
  },
  markets: {
    title: 'Buy Skycoin',
    loading: 'Loading, please wait...',
    description: 'Buy Skycoin',
    disclaimer:
      'Please note that sending funds to crypto wolf before hitting "Start Transaction" will lead to transaction failure. Moreover, sending a different amount from the one indicated will also lead to transaction failure. Make sure that you have calculated the miner\'s fee in order to send the exact amount indicated',
    data: 'Market Data',
    contact: 'To list Skycoin and put your exchange here email ',
    video: 'How To Buy Skycoin Direct From Skycoin.com',
  },
  home: {
    title: 'Skycoin - Decentralize the Web',
    description: 'Skycoin is a new blockchain-based mesh-internet.',
    banner: {
      heading: 'Check out the Skycoin hardware gallery',
      button: 'View photos',
    },
    bannerStore: {
      heading: 'Order a Skyminer today!',
      button: 'Visit store',
    },
    hero: {
      heading: 'What is Skycoin?',
      slider: {
        revolutionary: {
          title: 'Skycoin is Revolutionary',
          description: 'A new Web3 ecosystem built from the ground up.',
        },
        obelisk: {
          title: 'Skycoin is Obelisk',
          description:
            'A new consensus protocol solving core inefficiencies in PoS and PoW.',
        },
        cx: {
          title: 'Skycoin is CX',
          description:
            'A new, powerful, turing complete language for distributed development.',
        },
        skywire: {
          title: 'Skycoin is Skywire',
          description:
            'A stronger, faster, more secure internet, networking protocol and bandwidth routing algorithm.',
        },
        fiber: {
          title: 'Skycoin is Fiber',
          description:
            'An infinitely scalable, fully customizable platform capable of Visa-like speeds and security.',
        },
      },
      buy: 'Buy Skycoin',
      // community: 'Community',
      // whitepapers: 'Whitepapers',
      wallet: {
        get: 'Download Wallet',
        // blurb: 'Skycoin is driving the new internet revolution.',
      },
    },
    // nav: {
    //   architecture: 'Architecture Overview',
    //   whitepapers: 'Skycoin Consensus White Papers',
    //   blockchain: 'Skycoin Blockchain',
    //   cx: 'CX',
    //   cxo: 'CXO',
    //   skywire: 'Skywire',
    //   viscript: 'Viscript',
    //   cryptoSphere: 'CryptoSphere VPN',
    //   messenger: 'Sky-messenger',
    //   mobileWallet: 'Mobile Wallet',
    //   bbs: 'BBS',
    // },
    // distributionEvent: {
    //   heading: 'Distribution event',
    //   body: 'The Skycoin distribution event has started. 1% (1 million) of Skycoin will be sold at a fixed price of 0.002 BTC / SKY.',
    //   participate: 'Participate',
    // },
    // blog: {
    //   heading: 'Latest news from blog',
    // },
    // aboutSkywire: {
    //   heading: 'What is Skywire?',
    //   lead: 'Skywire is the new internet. An incentivized mesh network poised to become the privacy protocol of the future.',
    //   paragraph: 'Skywire’s goal is to make corporate internet service providers a thing of the past by giving the internet back to the people with its revolutionary privacy protocol. Peer-to-peer technology with a grassroots ethos, Skywire’s new networking protocol promotes net neutrality and sharing without blocking, slowdowns or censorship.',
    //   button: 'Read More about Skywire, Powered by Skycoin',
    // },
    // technology: {
    //   header: 'Skycoin Technology and Ecosystem:',
    // },
    about: {
      //   heading: 'What is Skycoin?',
      //   lead: 'A currency for digital bandwidth, backed by the new internet. Fast transactions, no transaction fees, Skycoin is a third-generation cryptocurrency supporting a new free and open internet.',
      //   paragraph: 'Skycoin is the cryptocurrency of Skywire. That means Skycoin has a practical application more than simply acting as another digital currency. The way Skycoin works is this: When you pass something along the Skywire network, you earn Skycoin. When you need to access the bandwidth yourself, pay via Skycoin. It only takes seconds to send and receive, with thousands of transactions per second.',
      obelisk: 'learn more about obelisk',
      //   speed: {
      //     heading: 'Speed',
      //     body: 'We built Skycoin to compete with credit cards and services like AliPay/Apple Pay. Transactions happen in seconds, not minutes.',
      //   },
      //   privacy: {
      //     heading: 'Privacy',
      //     body: 'Skycoin makes it impossible to trace transactions by mixing transactions from multiple wallets to increase privacy using the CoinJoin protocol. ',
      //   },
      //   security: {
      //     heading: 'Security',
      //     body: 'Skycoin is more secure because it does not rely upon the good will of miners, it cannot be 51% attacked.',
      //   },
      //   ecosystem: {
      //     heading: 'Ecosystem',
      //     body: 'We’re building an ecosystem of real world applications on top of Skycoin starting with messaging, social media, and VPN.',
      //   },
    },
    network: {
      label: 'Digging deeper',
      heading: 'Obelisk',
      subheading: 'The Skycoin Consensus Algorithm',
      body:
        'At Skycoin, we want to bring users what they asked for: a true, decentralized network without central authority. To accomplish this task, we went beyond PoW and PoS to create a wholly new decentralized algorithm that reconfigures the inner workings of distributed systems. Our distributed consensus algorithm, Obelisk, succeeds in delivering just such a network.<br/><br/>Its web-of-trust style consensus prevents the development of centralized power. Skycoin requires no mining, is immune to 51% attack, and transactions occur in seconds. Decisions are made through community consensus, not based on the wishes of a few majority stakeholders.</p>',
    },
    miner: {
      heading: 'Explore Skyminer',
      subheading:
        'The Skycoin Skyminer is meticulously designed and configured to provide a rock-solid telecom backbone for the Skywire infrastructure. The custom-built hardware is focused on delivering maximum security, efficiency and performance to the software-defined network. The multi-board architecture enables each node to support an independent service on Skywire. By isolating the nodes, each service can safely operate independently of attacks on peripheral services. These service-providing nodes are managed by an OpenWRT router with strict packet forwarding and access control rules for additional security. Skyminers are paid in Coin Hours for providing services and security to the Skywire network.',
      link: 'Become a node',
      more: 'Learn more',
      morePhotos: 'View more photos',
      headingHardware: 'The Skycoin hardware suite continues to materialize',
    },
    press: {
      heading: 'Skycoin Picked As Top 5 Crypto Projects For 2018',
      subheading: 'The #1 Project to watch out for...',
      forbes:
        'Skycoin aims to provide a “new internet” that is global, decentralized, and not controlled by any country, corporation, or government entity.  For privacy gurus or net neutrality enthusiasts, this is a project to stay on top of.',
      huffingtonPost:
        'Net neutrality and consumer data privacy emerged as two key issues in tech in 2017. If you’re concerned about paying ridiculous fees to ISPs for unreliable coverage, having your data sold, or government monitoring and censorship - Skycoin provides hope. These are the core issues Skycoin is attempting to solve.',
    },
    ecosystem: {
      heading:
        'Skycoin Is The Most Advanced Web3 Application Platform In The World',
      subheading: 'Skycoin Ecosystem',
      fiber: {
        title: 'Fiber',
        text:
          'The infinitely-scalable and highly customizable parallel peer-chain architecture of the Skycoin platform.',
      },
      obelisk: {
        title: 'Obelisk',
        text:
          'The “web of trust”, a new kind of consensus algorithm solving the fundamental flaws with PoW & PoS.',
      },
      skycoin: {
        title: 'Skycoin',
        text:
          'The most powerful and complete value transfer platform ever created.',
      },
      coinHours: {
        title: 'Coin Hours',
        text:
          'Accrued by holding Skycoin, Coin Hours are the payment mechanism for services on the Skycoin platform.',
      },
      coinJoin: {
        title: 'Coin Join',
        text:
          'Native platform support for CoinJoin to provide completely private, untraceable transactions.',
      },
      skyledger: {
        title: 'Skyledger',
        text:
          'Platform for launching your very own ICO on top of Fiber, our blockchain technology.',
      },
      skywire: {
        title: 'Skywire',
        text:
          'The new Decentralized Internet, a wireless mesh network that pays you for supporting it.',
      },
      skyminer: {
        title: 'Skyminer',
        text:
          'The hardware backbone for an unbreakable decentralized internet. Get paid for providing bandwidth, storage, and cpu power while you sleep.',
      },
      nodes: {
        title: 'Nodes',
        text:
          'The building blocks of the Skywire network, deployable by anyone to ensure decentralization of the Skywire ecosystem.',
      },
      cx: {
        title: 'CX',
        text:
          'A custom built programming language, developed on top of Golang. Designed to be easy to learn and fast to implement.',
      },
      cxo: {
        title: 'CXO',
        text:
          'A peer-to-peer cloud storage service tailored to service the distributed network of Skywire.',
      },
      kittyCash: {
        title: 'KittyCash',
        text:
          'The most popular application currently built on Fiber. Kittycash is a complete gaming ecosystem, powered by cats.',
      },
      skyVpn: {
        title: 'SDN',
        text:
          'Built-in end-to-end virtual private encryption over the Skywire network to ensure privacy.',
      },
      skyMessenger: {
        title: 'SkyMessenger',
        text:
          'Our fully encrypted messenger service, free from prying eyes or bad actors.',
      },
      bbs: {
        title: 'BBS',
        text: 'The framework for building distributed social network services.',
      },
    },
    news: {
      heading: 'News',
    },
    signup: {
      heading:
        'Join Our Skyfleet Newsletter and Soar to New Heights with Skycoin!',
      body:
        'Stay current, receive updates from the Skycoin team, and enjoy the progress by subscribing to our newsletter! Enter your personal email address & prepare for liftoff today.',
      button: 'Sign Up',
    },
    // roadmap: {
    //   heading: 'Roadmap',
    //   blurb: 'Visit GitHub to follow or contribute to Skycoin’s continued development and deployment. We will be opening bounties for bug fixes, design and development in the coming months.',
    //   roadmapLink: 'See the full roadmap',
    //   link: 'See our roadmap [pdf]',
    //   mobileLink: 'Skycoin Roadmap Mobile 2017',
    //   community: 'To keep up to date with Skycoin’s latest developments or to start contributing, join Skycoin on Telegram.',
    //   communityLink: 'Join the community',
    //   timeline: {
    //     network: {
    //       quarter: 'Q3',
    //       year: '2017',
    //       content: 'Launch of the first downloadable network node, users will be able to earn coins for powering the network.',
    //     },
    //     applications: {
    //       quarter: 'Q3',
    //       year: '2017',
    //       content: 'The launch of our first applications on the Skywire Network: a decentralised, Redditesque, social media platform and VPN service.',
    //     },
    //   },
    // },
  },
  whitepaper: {
    title: 'Whitepapers',
    description: 'Skycoin Consensus Whitepapers.',
  },
  downloads: {
    title: 'Downloads',
    description: 'Download Skycoin wallet.',
    wallet: {
      heading: 'Download Skycoin Wallet',
      headingDaemon: 'Download Skywallet Daemon',
      // lead: 'For simple use, download the Desktop wallet. For advanced use, or slow connections, the CLI wallet provides a UI that runs directly in your browser.',
      build: 'The current build is {version}.',
      disclaimer1: 'Notice: By downloading or operating the wallet software, you agree to the',
      disclaimer2: 'terms of service.',
      macos: 'MacOS',
      linux: 'Linux',
      windows: 'Windows',
      android: 'Android',
      ios: 'iOS',
      androidRecommended: 'Google Play Store',
      androidRecommendedComment: ' (recommended)',
      iosRecommended: 'Apple iOS App Store',
      iosRecommendedComment: ' (recommended)',
      androidAdvanced: 'APK',
      androidAdvancedComment: ' (advanced)',
      withElectron: 'Installer',
      withElectronComment: ' (recommended)',
      withoutElectron: 'Portable',
      withoutElectronComment: ' (advanced)',
      download: 'Download',
      instructions: 'Instructions',
      signature: 'Signature',
      torrent: 'Torrent',
      linuxDaemon: 'Daemon',
      linuxDaemonComment: '  ',
      macsDaemon: 'Daemon',
      macsDaemonComment: '  ',
      windowsDaemon: 'Daemon',
      windowsDaemonComment: '  ',
    },
    whitepaper: {
      title: 'Whitepapers',
      description: 'Skycoin wallet Whitepapers.',
    },
    bbs: {
      heading: 'Download Skycoin BBS',
      lead:
        "Skycoin BBS is a next generation decentralized social network built using Fiber, Skycoin's blockchain technology.",
      githublink: 'Find the latest binaries on Github.',
      thinclient: 'Access a BBS thin client.',
    },
    whitepapers: {
      heading: 'Download Skycoin Consensus Whitepapers',
      download: 'Download',
      skywalletManual: 'Skywallet User Manual',
      cryptocurrencyNetwork: '加密货币网络分布式共识算法白皮书',
      skyFramework:
        'Sky: an Opinion Dynamics Framework and Model for Consensus over P2P Network',
      skyHashConsensus:
        'SkyHash: an Opinion Dynamics Model for Hash Consensus over P2P network',
      skyHash: 'SkyHash: a Hash Opinion Dynamics Model',
      sznajd2: 'Sznajd2: a Community-aware Opinion Dynamics Model',
      distributedAlgorithm:
        'A Distributed Consensus Algorithm for Cryptocurrency Networks',
    },
    assets: {
      heading: 'Download Skycoin Branding Guide',
      guidelines: 'Skycoin Brand Guidelines',
      logo: 'Skycoin Logos',
      sch_logo: 'Coin Hours Logo Assets',
      font: 'Skycoin Sans font',
      branding: 'Skycoin品牌视觉规范 v1.6.1',
    },
    skywire: {
      heading: 'Download Skycoin Skywire Documentation',
      headingPackages: 'Download Skywire Packages',
      build: 'The current build is {version}.',
      linux: 'Linux',
      windows: 'Windows',
      macos: 'MacOS',
      installer: 'Installer',
      installerComment: '  ',
      package: 'Package',
      packageComment: '  ',
      installationGuide: 'Skywire Installation Guide v1.0',
      minerAssemblyManual: 'Skywire Miner Assembly Manual v2.3',
      minerAssemblyManualHiRes: 'Skywire Miner Assembly Manual v2.3 Hi-Res',
      skyminer: 'Skyminer矿机安装手册 v2.2',
    },
    roadmap: {
      heading: 'Roadmap',
    },
  },
  terms: {
    title: 'Terms of service',
    description: 'Terms of service',
    terms: 'By downloading or operating the wallet software, you agree to the terms and conditions. Any opinions made by any employee of Skycoin are their own personal views and are not the views of the Skycoin organization.',
  },
  thankYou: {
    message: 'Thank you! Your response has been recorded.',
  },
  // infographics: {
  //   title: 'Infographics',
  //   description: 'Graphical overview',
  // },
  // distribution: {
  //   title: 'Skycoin distribution event',
  //   description: 'On {date}, 1% (1 million) of Skycoin will be sold at a fixed price of 0.002 BTC / SKY.',
  //   hero: {
  //     heading: 'Skycoin distribution event',
  //     preEvent: 'On {begin}, 1% (1 million) of Skycoin will be sold at a fixed price of 0.002 BTC / SKY (500 SKY / BTC). This distribution event will stop on {end} or when 1% (1 million) SKY sells out, whichever is sooner.<br /><br />Check back to <a href="/distribution">skycoin.com/distribution</a> to participate in the event.<br /><br /><em>This event was originally scheduled for July 24, 2017 but has been rescheduled to August 8, 2017 due to uncertainty in the Bitcoin network during this time period.</em>',
  //     postEvent: 'The Skycoin distribution event ended on {date}. Join the Skycoin community on Telegram to stay up to date on upcoming distribution events.',
  //     participate: 'Participate',
  //   },
  //   countdown: {
  //     preEvent: 'The distribution event will begin on <strong>{date}</strong> at noon GMT.',
  //     eventInProgress: 'The distribution event will end on <strong>{date}</strong> at noon GMT.',
  //     days: 'Days',
  //     hours: 'Hours',
  //     minutes: 'Minutes',
  //     seconds: 'Seconds',
  //   },
  // },
  // roadmapPage: {
  //   heading: 'Development roadmap',
  // },
  ecosystem: {
    title: 'Ecosystem',
    description: 'Ecosystem',
    heading: 'Ecosystem',
    subheading: 'Architecture of the new internet',
    skycoin: {
      heading: 'Skycoin',
      body:
        'Skycoin was created as an answer to the shortcomings of both Bitcoin and Ethereum. Born out of necessity, no other coin was fulfilling Satoshi’s original vision of a fully decentralized digital currency.<br/><br/>Skycoin’s platform is free from centralization and manipulation through its revolutionary Obelisk consensus algorithm. It features CX, a turing complete programming language built from the ground up to allow hundreds of thousands of devs to easily deploy applications to the blockchain. Skycoin functions as a currency with virtually-free transactions, soon-to-be-implemented absolute privacy, and Visa-like speeds with inherent asset-backed value not based on speculation.<br/><br/>Holding Skycoin generates Coin Hours which are used to purchase services on the Skywire network and can be exchanged for more Skycoin.</p>',
      btn: 'learn more about cx',
    },
    skywire: {
      heading: 'Skywire',
      body:
        'It is fast. It doesn’t suffer from throttling and other service disruptions that you get with large ISPs.<br/><br/>It is private. This means that you can’t be tracked as you browse. Instead of paying $$$ per month to be tracked by the ISP (which then sells your browsing data without permission), the Skywire community will have internet service that protects their privacy.<br/><br/>It is incentivized. Skywire will develop to be a wireless mesh network (WMN). Users can earn both Skycoin and Coin Hours for running hardware nodes that provide both bandwidth and storage to the entire network. Users can then spend earned Coin Hours on content and other network resources, as they choose.<br/><br/>It is secure. Skywire is created by users for users. Users dictate the decisions made on the network and the network operates on a web of trust system where malicious nodes can be cut off from the main Skywire network via collective agreement of the community. This consensus model allows Skywire to be immune from attacks, exploitation and manipulation.<br/><br/>In an era where consumers are consistently being taken advantage of by large corporations in the name of profit, Skycoin’s Skywire network is a breath of fresh air. Skywire gives the power back to the people and creates a stronger, faster, and more secure internet in the process.</p>',
      skywireBtn: 'learn more about skywire',
      cxoBtn: 'learn more about cxo',
    },
    obelisk: {
      heading: 'Obelisk',
      body:
        'Decentralization in a centralized world.<br/><br/>Obelisk was created out of the shortcomings in the Proof of Work (PoW) and Proof of Stake (PoS) algorithms. Obelisk can never be centralized by mining pools or manipulated by shareholders, meaning it is truly decentralized. Obelisk distributes influence over the network according to a web-of-trust architecture. Instead of miners, the network consists of nodes. Each node gets its own personal blockchain which prevents and quarantines any potential bad actors. These nodes are substantially less expensive to produce, acquire and operate than any traditional miner used for Bitcoin or Ethereum. Obelisk was designed to be a scalable, computationally-inexpensive, zero-waste alternative to PoW. These features enable the algorithm to be run on budget hardware in a sustainable fashion, without wasting electricity or consuming valuable natural resources. Centralization becomes nigh-impossible when virtually anyone is able to operate a node.</p>',
      btn: 'learn more about obelisk',
    },
    experiments: {
      heading: 'Fiber',
      body:
        'The infinitely-scalable and highly customizable parallel peer-chain architecture of the Skycoin platform. Fiber is a better-than-blockchain solution, which is transformational in the way that it solves existing problems with distributed ledger technology.<br/><br/>Fiber is the foundation of “cryptocurrency 3.0”, an infinitely scalable network of blockchains laid side-by-side, like strands. Each project hosted on Fiber gets its own fully customizable, private blockchain capable of Visa-like speeds. Each strand added to Fiber strengthens the whole network and constructs the fabric of the entire ecosystem.<br/><br/>Skycoin Fiber does not compete with first and second generation cryptocurrency architectures, it replaces them. From fledgling blockchain projects to enterprises looking for solutions, Fiber is the answer.</p>',
      btn: 'learn more about fiber',
    },
    iconLabel: {
      fiber: 'Fiber',
      coinHours: 'Coin Hours',
      cx: 'CX',
      obelisk: 'Obelisk',
      coinJoin: 'Coin Join',
      skyminer: 'Skyminer',
      node: 'Node',
      cxo: 'CXO',
      bbs: 'BBS',
      skyMessenger: 'SkyMessenger',
      skyVPN: 'SDN',
      kittyCash: 'KittyCash',
    },
    about: {
      heading: 'What is Skycoin?',
      paragraph1:
        'The original purpose of digital currency was to reinvent the economy so that users could be independently empowered to trade in a peer-to-peer fashion, without interference from centralized powers. At Skycoin, we believe strongly in this mission. That’s why the Skycoin blockchain is designed to benefit all users, not just a select few. With Obelisk, we’re solving the problems inherent in PoW- and PoS-based coins to bring you a decentralized and democratic consensus network.',
      paragraph2:
        'Satoshi envisioned Bitcoin as a decentralized digital currency. Blockchain networks were intended to democratize finance, eliminating corporate control and spreading power among users. However, Bitcoin and related currencies have become centralized due to their reliance on Proof of Work (PoW) and Proof of Stake (PoS) algorithms, as well as their use of mining to create coins. This centralization defeats the original purpose of digital currencies.',
      paragraph3:
        'We created the Skycoin blockchain to correct these flaws. The Skycoin blockchain uses a novel consensus algorithm to replace PoW and PoS. It also fixes security problems associated with other blockchain networks and decouples coin creation from the mining process. The result is a fully decentralized cryptocurrency that fulfills Satoshi’s original vision.',
      paragraph4:
        'The Skycoin blockchain does not use mining, so user power cannot be concentrated in a few large mining pools as it is with Bitcoin today. Coin creation doesn’t give certain users disproportionate control over the network. The supply of Skycoin is fixed. Skycoin transactions occur in seconds and are more secure. With Skycoin, we’ve created an immutable cryptocurrency that functions as digital property, rather than a political tool for amassing control over networks.',
    },
    roadmap: {
      dev: {
        heading: 'Skycoin Development Roadmap',
      },
      marketing: {
        heading: 'Skycoin Marketing Roadmap',
      },
    },
  },
  skyminer: {
    title: 'Explore Skyminer',
    description: 'Skywire Miner: hardware for the new internet',
    hero: {
      heading: 'Skyminer: <br/>Hardware for the new internet.',
    },
    about: {
      heading: 'Explore Skyminer',
      subheading: 'Skywire Miner: hardware for the new internet',
      paragraph1:
        'The Skywire "miner" is meticulously designed and configured to provide a backbone for the new internet. Its custom-built hardware exceeds technical specifications to deliver maximum power and performance. Skywire functions as a “miner” for Skycoins. It acts as a specialized VPN, using the following hardware configuration:',
      paragraph2:
        'Each board features an ARM processor, 2 GB of RAM, and anywhere from 16 to 256 GB flash storage. The hardware is segmented in such a way that even if one service is compromised, the other services on the same machine can’t be. The setup can be further customized to consist of 4, 8, 16, or 32 boards.',
      paragraph3:
        'Nodes operating on the Skywire network will be receiving a network incentive reward to help build out the network, in addition to traffic forwarding payments. For the Skywire miners, we’d like to increase this network incentive reward. However, we’re still working out a mechanism for distinguishing the Skywire miners from other nodes, which could be any machine on the network.',
      list: {
        item0: '8 CPU boards',
        item1: '2 GB of RAM per board',
        item2: '4 CPU cores per board',
        item3: '16 GB of storage per board',
        item4: '64-bit Linux (Debian)',
        item5: '100 Mbps Ethernet, 8+1 port switch',
      },
    },
    video: {
      heading1: 'What Is A Skycoin Skyminer?',
      heading2: 'Introducing The Skycoin Skyminer',
      heading3: 'Unboxing the Skyminer',
      more: 'Watch more videos',
    },
    gallery: {
      heading: 'Gallery',
    },
    signup: {
      heading: 'Join The Skyminer Waitlist',
      body: 'Reserve your spot in the internet of tomorrow, today!',
    },
  },
  roadmap: {
    title: 'Skycoin Roadmap',
    description: 'Skycoin Roadmap',
    heading: 'Skycoin Development Roadmap',
  },
  skywire: {
    title: 'Skywire',
    description: 'Skywire - The Foundation of a New Internet',
    about: {
      heading: 'What is Skywire?',
      subheading: 'The Foundation of a New Internet ',
      quote: 'Everyone will be able to contribute to and benefit from Skywire.',
      paragraph1:
        'Skywire is the next evolutionary step in the internet’s development and use. We want to break the  chokehold that internet service providers (ISPs) have on the market by giving the power back to the  people. We are doing this by providing a decentralized community-driven mesh network where users  themselves will own and control the network’s infrastructure. Our goal is to provide everyone with access  to fast, secure, private and reliable internet.',
      paragraph2:
        'It is time to leave ISPs as a relic of the past. Customers routinely have their browsing data tracked, stored  and sold by ISPs, and at the same time experience unreliable coverage and poor customer service.  Instead of relying on corporate-owned networks, the Skywire mesh network runs on widespread  user-owned nodes which come together to provide the infrastructure for the network,  allowing  communities to power their internet access.',
    },
    features: {
      heading: 'Key Features:',
      speed: {
        title: 'Speed',
        text:
          'We’ve all experienced the network delays, outages and throttling that go hand in hand with current ISPs.  Skywire’s protocol is based on software-defined networking, which will make the outdated and inefficient  “hot-potato” packet routing a thing of the past.    Skywire supports channel bonding which provides unmatched speed and reliability. The ability to connect  to multiple nodes at once drastically increases throughput and redundancy, democratizing previously  difficult use cases.',
      },
      privacy: {
        title: 'Privacy',
        text:
          'With default end-to-end encryption, Skywire ensures that all traffic is private and users will never have  their data tracked, stored, or sold. Third parties will not be able to connect individual packets to any user  or IP address, and they will not be able to read the contents of any network traffic. Relaying nodes will  only have routing information for one single prior and subsequent node for movement of the encrypted  data packet. Users will finally be able to browse with real privacy.',
      },
      security: {
        title: 'Security',
        text:
          'Today, internet users have no say in how ISPs operate. Skywire gives this decision making power back to  the community in the form of a web-of-trust system. The consensus model allows nodes to be cut off if  deemed malicious, or strengthened if considered trustworthy through collective community agreement.  By making sure everyone has their say, Skywire becomes immune to exploitation, manipulation, and  attack, and safer for all.',
      },
      ecosystem: {
        title: 'Self-sustaining Ecosystem',
        text:
          'The backbone of Skywire will be the community itself. By providing Skycoin and Coin Hour rewards to  node operators, we offer incentives for people to contribute to the network and in turn, they’ll have Coin  Hours to use for resources and applications on the network. The more the network is used, the stronger,  faster and more robust it becomes, creating a closed-loop, self-sustaining economy.',
      },
      internet: {
        title: 'The Foundation of a New Internet',
        text:
          'Skywire lays the foundation for distributed bandwidth, storage, and computation essential to the new  peer-to-peer internet. In the future, this holy trinity of digital commodities will be affordable and easily  accessible to the world through Skywire. And in the not-too-distant future Skywire combined with the  ubiquity of Skywire Miners will provide the nodes to efficiently decentralize the limitless number of  blockchain applications that will run on Skycoin’s Fiber architecture.',
      },
    },
  },
  cxo: {
    title: 'CXO - CX Object Systems',
    description: 'CXO - CX Object Systems',
    about: {
      heading: 'What is CXO?',
      subheading: 'CX Object Systems',
      quote:
        'Skycoin is building a new ecosystem, consisting of the following components:',
      paragraph1:
        'CXO (CX Object Systems) is the Skycoin immutable object system, previously called Aether. Designed to replace current conventional methods of peer-to-peer sharing, CXO creates a robust storage system that supersedes services like BitTorrent, Dropbox, and Google Drive. Data is replicated peer-to-peer utilizing the Skycoin CXO library.',
      paragraph2:
        "CXO incorporates and expands on the protocols utilized in other blockchain-based storage networks. CXO is an IPLD, with a built-in schema that sets constraints to classify relatable databases. InterPlanetary File Systems (IPFS) can be built on top of CXO. CXO provides data distribution over the Skywire network and is useful for data that must be secure and verifiable yet doesn't need storage on the blockchain.",
      skywire: {
        title: 'Skywire',
        text: 'Skywire - Peer-to-peer community-driven decentralized',
      },
      cx: {
        title: 'CX',
        text: 'Specification and programming language',
      },
      cxo: {
        title: 'CXO',
        text:
          'Low-level library designed to house applications for sharing objects',
      },
    },
    features: {
      heading: 'Key Features:',
      sharing: {
        title: 'Data Sharing',
        text:
          'Useful for data owners who want to share information, as it can share many feeds like public keys. CXO nodes can subscribe to a feed to receive updates and can connect using the discovery server, interconnecting data based on interests.',
      },
      privacy: {
        title: 'Privacy',
        text:
          'CXO data exists collectively over the network. Once data is published, it cannot be destroyed, and data feeds are downloaded from peer subscribers. For privacy, the publisher’s location cannot be tracked as the publisher becomes merely a peer on the decentralized network',
      },
      security: {
        title: 'Security',
        text:
          'CXO exists within a self-contained standard ecosystem that is mathematically strict and is implemented from the ground up. The owners sign data using private keys, and users who receive the data can audit the signature through the use of public key feeds to be sure the data comes from the desired owner. Security is ensured because nodes cannot alter data without the use of the owner’s private keys.',
      },
      apps: {
        title: 'CXO Applications',
        text:
          'Applications on CXO are currently being tested with light use. SkyBBS is a social network similar to Facebook, Steemit, and Twitter, and is built on top of CXO, with many more to come.',
      },
    },
  },
  cx: {
    title: 'CX - CX programming language',
    description: 'CX - programming language',
    about: {
      heading: 'What is CX?',
      subheading: 'Programming language',
      paragraph1:
        'CX is Skycoin’s specification and programming language, packed full of features. CX will provide numerous advancements within the Skycoin project. It allows for the creation of complex contractual agreements that are built with security in mind.',
      paragraph2:
        'CX will deploy amendable obligations for projects built on the platform. These attributes are all part of the CX multi-purpose programming language.',
    },
    features: {
      heading: 'Features of CX:',
      affordances: {
        title: 'Affordances',
        text:
          'The utilization of affordances allows the permission of packages to be granted or rejected from specific users, aiding in the ability of programmers to confidently create secure code. The affordance system can be queried to obtain a list of actions that can be placed on functions.',
      },
      programming: {
        title: 'Genetic programming (GP)',
        text:
          'Genetic programming is an evolution in the creation of programs in CX. As a machine learning tool, GP will aid programmers by providing automatic problem-solving engines and the ability to perform curve-fitting and create predictive models.',
      },
      deterministic: {
        title: 'Deterministic Language',
        text:
          'Determinism allows CX programs to be created in confidence, negating the need for programmers to be concerned about the underlying machine in embedded environments, as outputs are produced invariably regardless of machinery.',
      },
      typing: {
        title: 'Strict Typing System',
        text:
          'The strict typing system of CX provides another layer or redundancy and ease of use, making the process of debugging a straightforward affair. Explicit type casting reduces errors and makes CX constitutionally secure for programmers.',
      },
      complied: {
        title: 'Compiled & Interpreted Language',
        text:
          'Functioning as both a compiled and interpreted language. This gives programmers the ability to leverage its advanced features with the added function of being flexible and interactive.',
      },
      garbage: {
        title: 'Garbage Collector',
        text:
          'A form of automatic memory management, the CX garbage collector automatically reclaims unused objects in the queue, freeing up valuable memory for necessary operations. CX finds data objects in the program that cannot be accessed in the future and disposes of them.',
      },
      object: {
        title: 'Object Explorer',
        text:
          'Programmers will have access to an object explorer which will show a graphical view of all objects and their current memory allocation. Those objects can be serialized and delivered, while code stepping will allow programmers to resume execution of those objects at the last state observed.',
      },
    },
    roadmap: 'CX Roadmap',
  },
  jobs: {
    title: 'Skycoin is hiring developers.',
    subtitle: 'We are hiring',
    sidebarTitle1:
      'Apply for a job by sending an email to jobs@skycoin.com with the following information:',
    sidebarTitle2: 'with this information:',
    sidebarList: {
      item_1: 'Position desired',
      item_2: 'Name',
      item_3: 'Time zone',
      item_4: 'Full-time or part-time',
      item_5: 'Telegram username',
      item_6: 'Resume (PDF)',
    },
    ourProject:
      'All of our projects are developed in Go and C. For frontend work, we use ',
    angular: 'Angular',
    or: ' or ',
    react: 'React.js.',
    ourTeam:
      'Our team is spread across the world and you will be working either remotely or at one of our offices in Shanghai. We communicate using',
    accordion1: {
      title: 'Technical Writer',
      responsibilities: {
        title: 'Responsibilities',
        item1:
          'Work on a remote team to create articles to communicate technical progress to readers',
        item2: 'Create and update technical documentation',
        item3: 'Create user manuals for various Skycoin projects',
      },
      requirements: {
        title: 'Requirements',
        item1:
          'Excellent English reading and writing skills as well as previous experience with technical writing.',
        item2:
          'Knowledge of concepts and technologies used in the software development process.',
      },
    },
    accordion2: {
      title: 'Software Engineer (Backend)',
      description:
        'Work on a fully remote team developing blockchain-, networking- and infrastructure-related software. Experience writing in Go (Golang) required.',
      projects: {
        title: 'A Sample of Active Projects',
      },
    },
    accordion3: {
      title: 'Firmware Engineer',
      description:
        'Work on a fully remote team developing firmware and embedded software for various hardware projects.',
      projects: {
        title: 'A Sample of Active Projects',
      },
    },
    accordion4: {
      title: 'Circuit Engineer',
      description:
        'Study relevant technical materials to compile the proper English materials for foreign members making up 80% of total team members. Good proficiency in English reading and writing is a requirement for admission.',
      responsibilities: {
        title: 'Responsibilities',
        item1:
          'Draw PCB Design drawing and circuit schematic diagram according to product requirements;',
        item2:
          'Edit the instruction documents for production, such as BOM format and screen mesh;',
        item3:
          'Carry out the selection of components and be in tune with suppliers on product supply;',
        item4: 'Carry out type testing and reliability testing;',
        item5: 'Write technical documents and file them.',
      },
      requirements: {
        title: 'Requirements',
        item1:
          "Hold a bachelor's degree or above in electronic engineering or related discipline;",
        item2:
          'Possess very strong English reading and writing skill in response to the search and quick study of technical materials and the daily conversation in an English-speaking environment;',
        item3:
          'Process the ability to proficiently design analog circuits and digital circuits, and read and draw schematic diagram skillfully;',
        item4:
          'Use Altium Designer or other same type software skillfully in response to the independent conduct for layout design of four-layer PCB board.',
        item5:
          'Possess the strong ability to circuit adjustment and test, and use common instruments skillfully;',
        item6:
          'Have a certain understanding of the model and supply chain of ordinary electronic components;',
        item7:
          'Think clearly, take initiative in working process, hold the ability in both strong executive and excellent self-study, and maintain good teamwork spirit.',
      },
      priority: {
        title:
          'High-priority candidates include those with any of the following conditions',
        item1:
          'Possess the ability to be familiar with English materials on Electronics Industry or the English-speaking proficiency;',
        item2:
          'Enable to use SolidWorks and other same types of 3D modeling software and to read mechanical drawings;',
        item3:
          'Have experience in the development of mechanical control programs, Raspberry Pi or Arduino;',
        item4:
          'Have knowledge or experience in any one of the following three sectors--- the Internet of things, communication, and integrated circuits;',
        item5: 'Understand the knowledge of blockchain well;',
      },
      program: {
        title: 'Internship Program',
        item1:
          'Submit at least one work about PCB Design, and relevant cites must be marked if any;',
        item2:
          'Welcome to all of outstanding undergraduates and fresh graduates to take part in internship plan. Upon completion of the internship period, satisfactory trainees shall be given permanent posts.',
      },
    },
    accordion5: {
      title: 'Mechanical Engineer',
      description: 'Description',
      study:
        'Study relevant technical materials to compile the proper English materials for foreign members making up 80% of total team members. Good proficiency in English reading and writing is a requirement for admission',
      responsibilities: {
        title: 'Responsibilities',
        item1:
          'Engage in design, study and optimization for the structure of mechanical products, creation of products, and improvement of product performance and quality;',
        item2:
          'Choose component, set up model machine, test product, and provide technical support for subsequent development work;',
        item3:
          'Solve problems during product development work and meet new requirement from users;',
        item4:
          'Provide the volume production of products with relevant technical data;',
        item5:
          'Play an active role in other aspects of company business needs.',
      },
      requirements: {
        title: 'Requirements',
        item1:
          "Hold a bachelor's degree or above in mechanical engineering or related discipline;",
        item2:
          'Possess very strong English reading and writing skill in response to the search and quick study of technical materials and the daily conversation in an English-speaking environment;',
        item3:
          'Use SolidWorks or related software proficiently in response to the independent conduct for establishment, modification and derivation of model. Experience in designing and managing model documents with components whose total volume is more than 100 are preferred;',
        item4:
          'Understand the supply chain of ordinary mechanical components well;',
        item5:
          'Think clearly, take initiative in working process with the ability in both strong executive and excellent self-study, and maintain good teamwork spirit.',
        item6: 'Must be on site in Shanghai.',
      },
      priority: {
        title:
          'High-priority candidates include those with any of the following conditions',
        item1:
          'Possess the ability to be familiar with English materials on machinery industry or English-speaking proficiency;',
        item2:
          'Understand circuit knowledge and use Altium proficiently for completing the PCB Design;',
        item3:
          'Have experience in the development of mechanical control programs, Raspberry Pi or Arduino;',
        item4: 'Understand the knowledge of blockchain well;',
      },
      propgram: {
        title: 'Internship Program',
        item1:
          'Submit at least one model completed by using Solidworks, and relevant cites must be marked if any;',
        item2:
          'Welcome to all of outstanding undergraduates and fresh graduates to take part in internship plan. Upon completion of the internship period, satisfactory trainees shall be given permanent posts.',
      },
    },
    accordion6: {
      title: 'Industrial Designer OR Intern',
      description: 'Description',
      subtitle:
        'Study relevant technical materials to compile the proper English materials for foreign members making up 80% of total team members. Good proficiency in English is a requirement for admission',
      responsibilities: {
        title: 'Responsibilities',
        item1: 'New product exterior design and 3D modeling;',
        item2:
          'Choose component, set up model machine, test product, and provide technical support for subsequent development work;',
        item3:
          'Provide the volume production of products with relevant technical data;',
        item4:
          'Play an active role in other aspects of company business needs.',
      },
      requirements: {
        title: 'Requirements',
        item1:
          "Hold a bachelor's degree or above in product design or related discipline;",
        item2: 'Have had one-year experience working in relevant sector;',
        item3: 'Have fluent English speaking, reading and writing;',
        item4:
          'Use SolidWorks or relevant 3D modeling software skillfully in response to the independent conduct for establishment, modification and derivation of model.',
        item5:
          'Possess the ability to be familiar with processing technology of common materials, and have a certain understanding of the supply chain for relevant parts;',
        item6:
          'Possess the ability to outstanding aesthetic judgment and creative thinking skill, take initiative in working process, good cooperation spirit and will of study. ',
        item7: 'Must be on site in Shanghai.',
      },
      priority: {
        title:
          'High-priority candidates include those with any of the following conditions',
        item1:
          'Possess the ability to read mechanical drawings or electrical drawings;',
        item2:
          'Use Adobe Illustrator or other same type graphic design software proficiently;',
        item3: 'Understand the knowledge of blockchain well;',
      },
      program: {
        title: 'Internship Program',
        item1:
          'Submit at least one design work completed independently and its introduction;',
        item2:
          'Welcome to all of outstanding undergraduates and fresh graduates to take part in internship plan. Upon completion of the internship period, satisfactory trainees shall be given permanent posts.',
      },
    },
    accordion7: {
      title: 'Blockchain Internship Engineer',
      description:
        'Carry out 90% of the tasks in English and work together with English-speaking members making up 80% of total team members. Good communication skills and proficiency in English are requirements for admission; experiences in large international companies are preferred. Upon completion of the internship period, satisfactory trainees shall be given permanent posts.',
      responsibilities: {
        title: 'Responsibilities',
        item1:
          'Study the principle of blockchain, operation mechanism and relevant algorithms;',
        item2:
          'Take part in the design, development and testing of blockchain products;',
        item3:
          'Solve problems during development and testing, and provide technical support for products;',
        item4: 'Write technical documents and file them.',
      },
      requirements: {
        title: 'Requirements',
        item1:
          'Undergraduates and fresh graduates majoring in computer science, software engineering, or related specialists;',
        item2:
          'Process the outstanding ability to excellent communication skills and good English reading and writing skills, and to learn code and relevant technical materials well;',
        item3:
          'Be passionate about the programming, be fond of studying technique, and be strongly interested in the blockchain technology;',
        item4:
          'Be proficient in at least one of the following sectors--- C/ C++, JAVA, GoLang, and Swift Programming Language development, and have good habits of programming and proficiency in file compilation;',
        item5: 'Have experience in developing Linux platform;',
        item6:
          'Master the technique in data structure and algorithm, and be familiar with network protocols such as TCP/IP, HTTP and P2P;',
        item7:
          'Think clearly, take initiative in working process, hold the ability in excellent self-study, and maintain good teamwork spirit.',
        item8:
          'Submit your GitHub account and at least one work, and relevant cites must be marked if any;',
      },
      priority: {
        title:
          'High-priority candidates include those with any of the following conditions',
        item1:
          'Possess the ability to be familiar with relevant professional English vocabularies, and to communicate and express English freely;',
        item2:
          'Have experience in research, development and practitioner of the projects related to blockchain;',
        item3:
          'Have experience in the network protocol development, such as DNP, P2P, etc. ',
      },
    },
    accordion8: {
      title: 'Operations Manager',
      description:
        'This is a flexible position. The operations manager will be responsible for improving internal business processes and leading teams for various business goals as needed. Strong communication and organizational skills are required. Work position is remote or on-site in Shanghai.',
    },
    accordion9: {
      title: 'Marketing Manager',
      responsibilities: {
        title: 'Responsibilities',
        item1:
          'Build, optimize and scale effective marketing campaigns to drive growth across digital marketing channels',
        item2:
          'Identify and test new innovative growth opportunities to deliver on goals',
        item3: 'Collaborate with internal teams / vendors',
        item4: 'Manage performance metrics and budget tracking',
        item5:
          'Generate and create data driven hypotheses to execute experiments across the marketing funnel to optimize conversion and other key performance metrics',
        item6:
          'Execute global marketing strategies with integrated campaigns focusing on user acquisition and brand awareness',
        item7:
          'Coordinate with content writers and social media manager to ensure message consistency across various channels',
        item8:
          'Tell stories with data, transforming it into insightful and easy to interpret visuals',
        item9: 'Maintain brand voice, design and messaging',
        item10:
          'Work closely with the Product and Engineering teams to launch features and products',
      },
    },
    accordion10: {
      title: 'Social Media Manager',
      responsibilities: {
        title: 'Responsibilities',
        item1: 'Represent our brand on social media channels',
        item2:
          'Deliver engaging and inspiring messages to our social audiences, with the goal of driving brand awareness and consideration',
        item3: 'Significantly grow our audience on social media',
        item4: 'Define and implement paid and organic growth strategies',
        item5:
          'Turn our high level marketing strategy into a social media strategy and calendar',
        item6: 'Prioritize between channels, posts and messages',
        item7:
          'Work together with influencers, internal, and external teams to build social content that engages and inspires large customer audiences',
        item8: 'Scale our social content across multiple markets and languages',
        item9: 'Drive engagement with our social community',
        item10:
          'Ensure communication excellence and convert audience feedback into reputation/brand-building moments',
        item11:
          'Drive and develop customer understanding through insightful analyses and actionable reporting',
        item12:
          'Work closely together with the marketing manager to drive a consistent and differentiated brand message to a mix of countries and audiences',
      },
    },
    accordion11: {
      title: 'Content Writer',
      requirements: {
        title: 'Requirements',
        item1: 'Strong knowledge in various media and marketing channels',
        item2: 'Must be able to write content that is SEO friendly',
        item3:
          'Candidate needs to be self-motivated, detail-oriented, problem solving and able to work as a team with staff and administrators; have excellent communication and organization skills',
        item4: 'Must have a popular blogging experience',
        item5: 'Highly proficient in Cryptocurrency and blockchain technology',
        item6: 'Adobe Photoshop basic skills',
        item7: 'Creative thinking skills',
        item8:
          'Strong proficiency in the English language and excellent writing skills',
        item9:
          'Ability to translate complex technical concepts into easily comprehensible articles',
        item10: 'Excellent writing, analysis, and research skills',
      },
    },
    accordion12: {
      title: 'SEO Engineer',
      description:
        'The SEO Engineer will devise and implement SEO strategies on our website properties and in external SEO campaigns.',
    },
  },
  whitelist: {
    heading: 'Skywire Reward Application Form',
    signUp: {
      title: 'Get Connected, Join Skywire & Get Rewarded!',
    },
  },

  skywallet: {
    title: 'Skywallet',
    about: {
      heading: 'Skywallet',
      subheading: 'SKYCOIN’S NEW HARDWARE WALLET',
      paragraph1: 'When you store or access your cryptocurrency, you are your own bank, so the process should be simple and intuitive. Your hardware wallet is your bank vault and it should feel like a premium and secure device. ',
      paragraph2: 'We’ve spent months iterating over designs and incorporating user feedback in order to make Skywallet the best hardware wallet experience on the market.',
    },
    features: {
      heading: 'Getting started',
      recovery_seed: {
        title: 'recovery seed',
        text: 'The  recovery  seed  is  a  backup  for  your  entire  device.  If  your device  is  lost  or  damaged,  you  can  recover  your  wallets  using the seed phrase. It is generated on your device and only shown once. It should go without saying that if somebody  finds  your  seed,  they  can  easily  clone  your  device. Do not store the seed or communicate it digitally. Support will never ask for your seed',
      },
      instructions: {
        title: 'instructions',
        text: 'Before  connecting  to  your  computer,  please  ensure  that  you have  the  latest  version  of  the  skycoin  desktop  wallet  installed available  at  skycoin.com.  If  it  is  already  installed,  simply  plug your  device  into your  computer  and  follow  the  instructions  on screen.',
      },
      treatment: {
        title: 'treatment',
        text: 'Do not expose the Skywallet to extreme temperatures or elements. It is not waterproof, heat or acid resistant.',
      },
      download: {
        title: 'download',
        text: '<ul> <li> <a href="https://downloads.skycoin.com/wallet/skycoin-0.27.0-cli-linux-arm.tar.gz" rel="noopener noreferrer" target="_blank" download>https://downloads.skycoin.com/wallet/skycoin-0.27.0-cli-linux-arm.tar.gz</a> </li><li> <a href="https://downloads.skycoin.com/wallet/skycoin-0.27.0-cli-linux-x64.tar.gz" rel="noopener noreferrer" target="_blank" download>https://downloads.skycoin.com/wallet/skycoin-0.27.0-cli-linux-x64.tar.gz</a> </li><li> <a href="https://downloads.skycoin.com/wallet/skycoin-0.27.0-cli-osx-darwin-x64.zip" rel="noopener noreferrer" target="_blank" download>https://downloads.skycoin.com/wallet/skycoin-0.27.0-cli-osx-darwin-x64.zip</a> </li><li> <a href="https://downloads.skycoin.com/wallet/skycoin-0.27.0-cli-win-x64.zip" rel="noopener noreferrer" target="_blank" download>https://downloads.skycoin.com/wallet/skycoin-0.27.0-cli-win-x64.zip</a> </li><li> <a href="https://downloads.skycoin.com/wallet/skycoin-0.27.0-cli-win-x86.zip" rel="noopener noreferrer" target="_blank" download>https://downloads.skycoin.com/wallet/skycoin-0.27.0-cli-win-x86.zip</a> </li><li> <a href="https://downloads.skycoin.com/wallet/skycoin-0.27.0-daemon-linux-arm.tar.gz" rel="noopener noreferrer" target="_blank" download>https://downloads.skycoin.com/wallet/skycoin-0.27.0-daemon-linux-arm.tar.gz</a> </li><li> <a href="https://downloads.skycoin.com/wallet/skycoin-0.27.0-daemon-linux-x64.tar.gz" rel="noopener noreferrer" target="_blank" download>https://downloads.skycoin.com/wallet/skycoin-0.27.0-daemon-linux-x64.tar.gz</a> </li><li> <a href="https://downloads.skycoin.com/wallet/skycoin-0.27.0-daemon-osx-darwin-x64.zip" rel="noopener noreferrer" target="_blank" download>https://downloads.skycoin.com/wallet/skycoin-0.27.0-daemon-osx-darwin-x64.zip</a> </li><li> <a href="https://downloads.skycoin.com/wallet/skycoin-0.27.0-daemon-win-x64.zip" rel="noopener noreferrer" target="_blank" download>https://downloads.skycoin.com/wallet/skycoin-0.27.0-daemon-win-x64.zip</a> </li><li> <a href="https://downloads.skycoin.com/wallet/skycoin-0.27.0-daemon-win-x86.zip" rel="noopener noreferrer" target="_blank" download>https://downloads.skycoin.com/wallet/skycoin-0.27.0-daemon-win-x86.zip</a> </li><li> <a href="https://downloads.skycoin.com/wallet/skycoin-0.27.0-gui-electron-linux-x64.AppImage" rel="noopener noreferrer" target="_blank" download>https://downloads.skycoin.com/wallet/skycoin-0.27.0-gui-electron-linux-x64.AppImage</a> </li><li> <a href="https://downloads.skycoin.com/wallet/skycoin-0.27.0-gui-electron-osx.dmg" rel="noopener noreferrer" target="_blank" download>https://downloads.skycoin.com/wallet/skycoin-0.27.0-gui-electron-osx.dmg</a> </li><li> <a href="https://downloads.skycoin.com/wallet/skycoin-0.27.0-gui-electron-win-setup.exe" rel="noopener noreferrer" target="_blank" download>https://downloads.skycoin.com/wallet/skycoin-0.27.0-gui-electron-win-setup.exe</a> </li><li> <a href="https://downloads.skycoin.com/wallet/skycoin-0.27.0-gui-standalone-linux-arm.tar.gz" rel="noopener noreferrer" target="_blank" download>https://downloads.skycoin.com/wallet/skycoin-0.27.0-gui-standalone-linux-arm.tar.gz</a> </li><li> <a href="https://downloads.skycoin.com/wallet/skycoin-0.27.0-gui-standalone-linux-x64.tar.gz" rel="noopener noreferrer" target="_blank" download>https://downloads.skycoin.com/wallet/skycoin-0.27.0-gui-standalone-linux-x64.tar.gz</a> </li><li> <a href="https://downloads.skycoin.com/wallet/skycoin-0.27.0-gui-standalone-osx-darwin-x64.zip" rel="noopener noreferrer" target="_blank" download>https://downloads.skycoin.com/wallet/skycoin-0.27.0-gui-standalone-osx-darwin-x64.zip</a> </li><li> <a href="https://downloads.skycoin.com/wallet/skycoin-0.27.0-gui-standalone-win-x64.zip" rel="noopener noreferrer" target="_blank" download>https://downloads.skycoin.com/wallet/skycoin-0.27.0-gui-standalone-win-x64.zip</a> </li><li> <a href="https://downloads.skycoin.com/wallet/skycoin-0.27.0-gui-standalone-win-x86.zip" rel="noopener noreferrer" target="_blank" download>https://downloads.skycoin.com/wallet/skycoin-0.27.0-gui-standalone-win-x86.zip</a> </li></ul>',
      },
    },
  },
  fiber: {
    title: 'Fiber',
    description:
      'Fiber is Blockchain 3.0 Innovation with Advanced Peer-Chain Architecture',
    about: {
      heading: 'What is Fiber?',
      subheading:
        'Blockchain 3.0 Innovation with Advanced Peer-Chain Architecture',
      quote:
        '“Skycoin’s Fiber architecture is a transformational, better-than-blockchain solution which solves existing problems using distributed ledger technology. Fiber is the foundation of blockchain 3.0 and can be best described as an infinitely scalable network of blockchains laid side by side, like strands. This is a technological feat that cryptocurrencies such as Bitcoin or Ethereum will never be able to achieve, as they were never engineered to scale infinitely.”',
      author: 'medium source',
      paragraph1:
        'Fiber is the structural layer of Skycoin’s blockchain platform that is custom built to be adaptable to any blockchain application’s needs.  Running on an innovative and extremely efficient code, Fiber enables the Skycoin platform to scale into and disrupt veritably every industry with blockchain solutions.',
      paragraph2:
        'Fiber is as sophisticated as it is elegant, capable of expanding and adapting to the needs of numerous types of distributed applications.',
    },
    features: {
      heading: 'The Advantages of Fiber',
      system: {
        title: 'Truly Symbiotic Peer-Chain System',
        text:
          'Skycoin’s Fiber architecture enables scaling of the Skycoin platform laterally as well as vertically without compromising dependencies or network deficiencies at scale.  Thanks to Skycoin’s <a href="https://medium.com/skycoin/skycoin-obelisk-8cc32bc9ca37" target="_blank" rel="noopener noreferrer">Obelisk</a> consensus mechanism, every token supported by Fiber will be fundamentally isolated from others such that they will never impact one another regarding network stability, security, or throughput.  Additionally, through the Skycoin <a href="https://medium.com/skycoin/skycoin-coin-hours-f537fa7ae614" target="_blank" rel="noopener noreferrer">Coin Hour</a> system, every project that leverages Fiber will advance the entire Skycoin platform forward, without hindering the existing platform operations.  Fiber creates an unprecedented level of symbiosis between projects while maintaining enough isolation such that no one tokens can negatively impact the remainder of the network.',
      },
      forking: {
        title: 'Forking Done Right',
        text:
          'Tokens running on Fiber will be forks of the Skycoin core code, which means that every project will have the same level of advanced features, throughput, and security as Skycoin.',
      },
      blockchain: {
        title: 'Customized Blockchain',
        text:
          'Projects running on Skycoin Fiber will have their own fully independent and highly customizable blockchain to fit their unique needs. It is fundamentally naive to assume that one set of rules or operations will fulfill the requirements of a wide range of projects, meaning adaptability is the most crucial factor of a blockchain platform that aims to successfully scale both vertically and laterally.',
      },
      token: {
        title: 'True Token Support',
        text:
          'Tokens built on Skycoin’s Fiber architecture will have an unprecedented level of network support. Tokens will be able to run on our groundbreaking peer-to-peer network, Skywire, and each token will have immediate wallet and exchange support within the Skycoin ecosystem.  That’s right, a project can launch and trade within a matter of minutes on our world-class platform.',
      },
      operation: {
        title: 'Independent Operation',
        text:
          'As Skywire develops into a global peer-to-peer mesh network, Fiber tokens running on Skywire will be completely independent of reliance on traditional network infrastructure like internet service providers.  This platform independence is unique to Skycoin’s Fiber and its distributed applications and projects.',
      },
    },
  },
  skyminerForm: {
    title: 'Skyminer Order Information',
  },
  obelisk: {
    title: 'Obelisk',
    description: 'Obelisk - The Revolutionary Skycoin Consensus Algorithm',
    about: {
      heading: 'What Is Obelisk?',
      subheading: 'The Revolutionary Skycoin Consensus Algorithm',
      quote:
        '“Centralization issues, 51% attacks, mining problems, slow transaction speeds and energy waste are only a few of the critical disadvantages that old consensus algorithms face. To counter this, Skycoin has developed Obelisk, the new distributed consensus algorithm that solves the problems of previous generations and makes them obsolete.”',
      author: 'medium source',
      paragraph1:
        'Obelisk is a revolutionary web-of-trust consensus algorithm built to eliminate the issues that previous generations of consensus have introduced into the blockchain space. Web-of-trust architecture creates a perfect system of checks and balances, allowing the community and other nodes the ability to audit network behavior with a high degree of accuracy.',
      paragraph2:
        'With the ability to cut off suspicious nodes for malicious behavior, the network becomes stronger as trust is maintained. The quarantine of nodes can manage trust, and at the same time, this process allows the community to rebalance power in the network.',
    },
    features: {
      heading: 'Features of Obelisk',
      consumption: {
        title: 'Low Energy Consumption & Highly Scalable',
        text:
          'The consensus algorithm was designed to be a scalable and computationally inexpensive alternative to Proof-of-Work (PoW), enabling both the algorithm and block-making to run on budget open-source hardware.',
      },
      attack: {
        title: 'Immune to 51% Attack',
        text:
          'Web-of-trust consensus prevents the development of centralized power. Skycoin does not rely on mining incentives and therefore is not susceptible to the same PoW/PoS vulnerabilities.',
      },
      defence: {
        title: 'Robust Defense',
        text:
          'Obelisk can withstand a large-scale coordinated attack by a well-organized network of malicious nodes. The algorithm is non-iterative, converges fast, and can run on a sparse arrangement of nodes with only nearest-neighbor connectivity, as it would on a mesh network.',
      },
      structure: {
        title: 'Two-Node Structure',
        text:
          'A Consensus Node receives its input from one or more Block-Making nodes. The algorithms are separate for each, yet they both operate on the same data structures. Both type of nodes always perform authorship verification and fraud detection of incoming data. Fraudulent or invalid messages are detected, dropped, and never propagated, thus peer nodes engaged in suspicious activities will be severed, and their public keys are banned.',
      },
    },
  },
  gallery: {
    title: 'Gallery',
    description: 'Gallery',
    heading: 'Gallery',
    antennas: {
      heading: 'Biquad Yagi Antenna',
    },
    cantennas: {
      heading: 'Cantennas Antenna',
    },
    wallet: {
      heading: 'Skywallet',
    },
    wallethdk: {
      heading: 'Skywallet HDK',
    },
    skyminer: {
      heading: 'Skyminer',
    },
    diySkyminer: {
      heading: 'DIY Skyminers',
    },
  },
  landing: {
    skyware: {
      hero: {
        title: 'Skywire',
        heading:
          'Skywire is the next evolutionary step in the internet’s development and use. Our goal is to provide everyone with access to fast, secure, private and reliable internet.',
        button: 'Learn more',
      },
      watchNow: {
        title: 'Watch now!',
        description:
          'Check out these YouTube videos to learn more about Skywire',
        youtube: {
          what: 'What is Skywire?',
          solution: 'A Solution to Censorship',
          isp: 'Why ISPs need to be Replaced',
        },
      },
      afee: {
        text:
          '“To free Crypto from the bonds of corrupt power, we need more than distributed exchanges. We need to bypass the existing Internet. Mesh networks solve this problem. Skywire  is the only one designed by and for the Crypto Space.” ',
        name: 'John McAfee',
      },
      divider:
        'Everyone will be able to contribute to and benefit from Skywire',
      bottom: {
        text:
          'Its <b>private</b>, <b>secure</b> and <b>decentralized</b>. Join over 1,450+ nodes now on Skywire with our current special promotion!',
      },
      features: {
        speed: {
          title: 'Speed',
          description:
            'Skywire’s protocol is based on software-defined networking, which will make the outdated and inefficient  “hot-potato” packet routing a thing of the past.',
        },
        privacy: {
          title: 'Privacy',
          description:
            'With default end-to-end encryption, Skywire ensures that all traffic is private and users will never have  their data tracked, stored, or sold.',
        },
        security: {
          title: 'Security',
          description:
            'Today, internet users have no say in how ISPs operate. Skywire gives this decision making power back to  the community in the form of a web-of-trust system.',
        },
        ecosystem: {
          title: 'Self-sustaining ecosystem',
          description:
            'By providing Skycoin and Coin Hour rewards to  node operators, we offer incentives for people to contribute to the network.',
        },
        internet: {
          title: 'Foundation of the new internet',
          description:
            'Skywire lays the foundation for distributed bandwidth, storage, and computation essential to the new  peer-to-peer internet',
        },
      },
    },
    cx: {
      hero: {
        title: 'CX',
        heading:
          "CX is Skycoin's specification and programming language, packed full of features. It allows for the creation of complex contractual agreements that are build with security in mind.",
        button1: 'Download now',
        button2: 'Learn more',
      },
      watchNow: {
        title: 'Watch now!',
        description:
          'Check out the video below to get an introduction on the CX programming language by the lead developer Amaury Aguila. ',
        youtube: {
          introduction: 'CX Introduction',
        },
      },
      start: {
        title: 'Start now!',
        description:
          'Download CX now and start working on a project.  Join the CX group on Telegram to share your work, get help, gain inspiration and much more.  There is even a group dedicated to making games with CX.',
      },
      divider:
        'CX will provide numerous advancements within the Skycoin project.',
      features: {
        affordance: {
          title: 'Affordances',
          description:
            'The utilization of affordances allows the permission of packages to be granted or rejected from specific users, aiding in the ability of programmers to confidently create secure code.',
        },
        typing: {
          title: 'Strict typing system',
          description:
            'Explicit type casting reduces errors and makes CX constitutionally secure for programmers.',
        },
        object: {
          title: 'Object explorer',
          description:
            'Programmers will have access to an object explorer which will show a graphical view of all objects and their current memory allocation.',
        },
        more: {
          title: 'More features...',
          list: {
            deterministic: 'Deterministic language',
            compiled: 'Compiled & interpreted language',
            extensive: 'Extensive documentation',
            active: 'Active development',
            videogame: 'Video game development',
            system: 'Mac, Linux and Windows support',
          },
        },
      },
      bottom: {
        text:
          'Start developing now with CX. Either download it from Github or try the CX playground.',
        button1: 'Download',
        button2: 'CX Playground',
      },
    },
    skywallet: {
      title: 'Skywallet',
      hero: {
        title: 'Skywallet',
        heading:
          'Your hardware multi-coin wallet is your bank vault and it should feel like a premium and secure device.  Shipping Q1 2019. Order now!',
        button: 'Order now',
      },
      features: {
        learnMore: 'Learn more',
        live: {
          title: 'Skywallet Live',
          description:
            'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna.',
        },
        security: {
          title: 'Security',
          description:
            'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. ',
        },
        support: {
          title: 'Customer support',
          description:
            'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. ',
        },
        intuitive: {
          title: 'Intuitive',
          description:
            'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. ',
        },
        included: {
          title: 'Included',
          description:
            '<ul><li>Micro-USB 2.0 cable</li><li>Recovery phrase</li><li>Keychain</li></ul>',
        },
      },
    },
    skyminer: {
      title: 'The Skyminer',
      description: 'The Skyminer',
      hero: {
        title: 'The Skyminer',
        heading:
          'Meticulously designed using open standards and configured to become a node in the backbone of Skywire, the ‘miner’ is your key to participating in the new Internet and to earn SKY for doing so.',
        button: 'Learn more',
      },
      hardware: {
        title: 'Hardware',
        description: `
          <li>8 CPU boards</li>
          <li>2 GB of RAM per board</li>
          <li>4 CPU cores per board</li>
          <li>16 GB of storage per board</li>
          <li>64-bit OS (Debian)</li>
          <li>100 Mbps Ethernet, 8+1 port switch</li>
          <li>Custom aluminum & Plexigas case</li>
        `,
      },
      operate: {
        text:
          'Earning is easy with a Skyminer!<br>Participate in the network using your Skyminer and <b>get paid SKY</b> for doing so.',
      },
      watchNow: {
        title: 'Watch and learn!',
        description:
          'Check out this collection of Youtube videos to gain a deeper understanding of Skyminer. ',
        youtube: {
          video1: 'What is a Skyminer?',
          video2: 'Unboxing the Skyminer',
          video3: 'Introducing the Skyminer',
        },
      },
      support: {
        title: 'Top-notch Support – we’ve got your back',
        description:
          'With the purchase of a Skyminer you automatically get access to super fast email support from our help desk support ticket system. Additionally, our Telegram Skywire community consisting of over 2000 members, also offers community based support.   ',
      },
      orderNow: {
        text:
          'Skywire. <b>private</b>, <b>secure</b> and <b>decentralized</b>. Join the future now with a Skyminer and become one of an ever-growing number of nodes on the Skywire network. ',
      },
      forbes: {
        title: 'Forbes’ #1 project picked for 2019',
        description:
          '“Skycoin aims to provide a new internet that is global, decentralized, and not controlled by any country, corporation or government. For privacy gurus or net neutrality enthusiasts… this is a project to stay on top of.”',
      },
    },
    skycoin: {
      title: 'Skycoin',
      description: 'Skycoin Landing Page',
      hero: {
        title: 'Skycoin',
        heading1: 'Skycoin is next generation Blockchain technology.',
        heading2:
          'Skycoin was created by developers who have been involved in cryptocurrency since the early days. They saw the shortcomings of the first cryptos and created Skycoin as a solution.',
        button: 'Download Wallet',
        button2: 'Buy Skycoin Now!',
      },
      ecosystem: {
        title: 'Skycoin is an ecosystem',
        description: `
          <li>Skycoin, the currency</li>
          <li>Skywire, the new Internet</li>
          <li>Obelisk, the new consensus algorithm</li>
          <li>Sky Fiber, the new platform</li>
          <li>CX, the new programming language</li>
        `,
      },
      learnmore: {
        text:
          'The Skycoin ecosystem is made up of hardware and software that was carefully designed to work together synergistically and to make the best possible use of Blockchain technology.',
        button: 'LEARN MORE ABOUT THE SKYCOIN ECOSYSTEM',
      },
      watchandlearn: {
        title: 'Watch and learn!',
        description: 'Check out the videos below.',
        youtube: {
          video1: 'The fully distributed payment network',
          video2: 'The currency of a new Internet',
          video3: 'Third generation cryptocurrency',
          video4: 'Building the new Internet for the new world',
        },
      },
      wallet: {
        title: 'Skycoin Wallet',
        description:
          'Easy to use, safe and secure. Whether you prefer a mobile or desktop platform, we have a Skycoin wallet especially for your operating system of choice. Skycoin wallet is available for Windows, Linux, Mac, Android and iOS.',
        button: 'Download Wallet',
      },
      orderNow: {
        text:
          'Skycoin. Decentralised in the true sense of the word, easy to work with, and secure, Skycoin is the answer to the shortcomings of early cryptocurrencies',
        button: 'Order Now',
      },
      buying: {
        title: 'Buying Skycoin is easy',
        description:
          'There’s nothing cryptic about buying Skycoin. Use your credit card, current crypto holdings or fiat money to buy Skycoin directly from our website or from one of the quality exchanges that list Skycoin.',
        button: 'Buy Skycoin Now!',
      },
    },
    mobileWallets: {
      title: 'Mobile Wallet',
      description: 'Skycoin Mobile Wallet Landing Page',
      hero: {
        title: 'Skycoin Mobile Wallet',
        heading1:
          'Secure mobile solutions for holding, sending, and receiving Skycoin.',
        heading2: "The Skycoin mobile wallet offers Skycoin users an on-the-go platform for transacting with SKY that is free of charge, safe, and easy to use. For the users' convenience, the Skycoin mobile wallet is available on both Android and iOS.",
        button: 'Download Wallet',
      },
      accessible: {
        title: 'Accessible, easy to install, easy to use',
        description: `
          <li>Available for free on the App Store, Play Store, or as an APK on the Skycoin website</li>
          <li>Simple one-click installation</li>
          <li>Intuitive user interface that is easy to understand</li>
          <li>Advanced functionality is available for experienced users</li>
          <li>Language support for Japanese, Spanish, and Chinese users</li>
        `,
        button: 'Download for iOS',
        button2: 'Download for Android',
      },
      watchandlearn: {
        text: "The Skycoin mobile wallet was meticulously designed to be accessible to as many users as possible, regardless of the users' experience level. Advanced functionality that may be required by experienced users is located on a separate tab and multiple language support ensures ease of access to many non-English speaking users.",
        textMobile: "The Skycoin mobile wallet was meticulously designed to be accessible to as many users as possible, regardless of the users' experience level.",
        button:
          'Watch and see how easy it is to transact with Skycoin mobile wallet',
      },
      learnMore: {
        text: 'Free to download, easy to install, secure to use. The Skycoin mobile wallet is the key that unlocks the door to the entire Skycoin ecosystem.',
        button: 'Learn more about the Skycoin ecosystem',
      },
      secure: {
        title: 'Skycoin mobile wallet is secure and safe to use',
        description:
          'Security is a top priority for all Skycoin products and the Skycoin mobile wallet is no exception. With hardware encrypted keys and a user selected pin of up to six digits, you can rest assured that your Skycoin remains where it belongs.',
      },
    },
  },
  exchanges: {
    any: 'Any',
    title: 'Exchanges',
    description: 'Exchanges',
    exchanges: 'Exchanges',
    empty: ' ',
    lbank: 'LBank',
    c2cx: 'C2CX',
    bitbns: 'Bitbns',
    xbts: 'XBTS',
    coindcx: 'CoinDCX',
    table: {
      headers: {
        name: 'Name',
        link: 'Link',
        markets: 'Markets',
      },
    },
  },
  pressreleases: {
    any: 'Any',
    title: 'Press Releases',
    description: 'Press Releases',
    pressreleases: 'Press Releases',
    releases: {
      title: 'Skycoin Announces Public Release of Skywire Mainnet',
      description: 'Skycoin Announces Public Release of Skywire Mainnet',
      dates: 'March 20, 2019',
      content: {
        description: '<p>Skycoin has unveiled the developer version of their Skywire application. Developers will now be able to download, install, build, and run the Skywire mainnet utilizing a command line interface. Full developer documentation will be released over the next few weeks.</p><p><strong>SHANGHAI, March 19, 2019 /PRNewswire/ </strong>-- Work on Skycoin began in 2011 with the merging of three separate projects that aimed to improve upon the design and implementation of Bitcoin. The Skycoin developers identified several major philosophical design issues that they saw as obstacles to global use of cryptocurrency as a censorship-resistant payment system.</p><p>Skywire, the decentralized internet protocol and mesh network, was created as a solution to answer many of these problems.</p><p><strong>Skywire Mainnet is here for Developers to Test</strong></p><p>After about ten months of intensive testing on a network of nearly 10,000 nodes spanning the globe, Skycoin is happy to announce that the developer version of Skywire&apos;s mainnet is now available to the public. Its official launch date was the 4th of March 2019.</p><p>This first iteration of Skywire&apos;s mainnet features entirely rewritten software from the ground up and is primarily focused on a platform for developers to start building the next generation of distributed apps. All existing apps have been rewritten and optimized for the mainnet including a distributed and secure chat app, SSH, and a multi-hop tunneling proxy app. Many more will be coming soon.</p><p> <a href="https://www.blog.skycoin.com/posts/skywire-mainnet-public-testing-announcement/" rel="noopener noreferrer" target="_blank">This first version of Skywire&apos;s mainnet represents a huge milestone for Skycoin and for the future of the internet.</a> Skywire will serve as an unstoppable, highly resilient network, removing any possibility of censorship. </p><p>Skywire mainnet&apos;s developer build is the first release of many. Over the course of the next few months, Skycoin will be releasing new iterations and features for Skywire – one of these is an updater that allows Skycoin to push new features constantly – stay tuned for additional information, technical details, and further updates from the team.</p><p> <a href="https://github.com/skycoin/skywire/tree/mainnet" rel="noopener noreferrer" target="_blank">Skywire Mainnet on Github</a> </p><p>Please note: Do not install this on your skyminers as they are running testnet and will stop receiving rewards. Skywire mainnet can be installed on any other device to run, test and develop.</p><p>Bug reporting should be done through the repo, with steps taken to reproduce any feedback. Details of the process will be available in the readme section of the branch.</p><p><strong>What&apos;s Next for Skywire?</strong></p><ul> <li>A new and intuitive UI for developers and users to easily interact with the mainnet</li><li>Bandwidth monetization will be coming soon that will allow users to earn Coin Hours through bandwidth sharing</li><li>Coin Hours bank</li><li>Private Skycoin transactions utilizing CoinJoin</li><li>Remote management of unlimited nodes</li><li>Combining the CXO protocol with Skywire for distributed data storage</li></ul> <p><strong>About Skycoin</strong></p><p>Skycoin is a third generation blockchain company that has its own chain, consensus algorithm, programming language, hardware, and their flagship product Skywire which is a decentralized community-driven mesh network where users themselves will own and control the network&apos;s infrastructure. Skywire&apos;s goal is to provide everyone with access to fast, secure, private and reliable internet.</p>',
      },
    },
    releases_part: {
      title: 'Early Bitcoin and Ethereum Developers Set to Roll-Out "Skywire" - a New, Decentralized Internet from Skycoin',
      description: 'Early Bitcoin and Ethereum Developers Set to Roll-Out "Skywire" - a New, Decentralized Internet from Skycoin',
      dates: 'August 23, 2019',
      content: {
        description: '<p>Skywire is Designed to Eliminate the Privacy and Security Issues Found on the Internet</p><p><strong>SHANGHAI, CHINA / ACCESSWIRE / August 23, 2019 /&nbsp;</strong>After nearly a decade of development, the team behind the third-generation cryptocurrency Skycoin are ready to unveil their groundbreaking flagship project: a new, decentralized Internet called Skywire. Built from the ground up using cutting-edge new technology, Skywire was designed to completely eliminate the privacy and security deficiencies of the Internet as everyone knows it.</p><p>“Skycoin has created the foundation for a new decentralized Internet and the most advanced blockchain application platform in the world,” a spokesperson for Skycoin said, adding that over 10,000 hardware nodes have already been deployed for Skywire around the globe. These nodes, part of sophisticated custom hardware and software called Skyminers, form the backbone of this new Internet. More Skyminer nodes coming online means that the potential reach of Skywire is growing.Skywire is designed to be fundamentally faster than the current Internet, as well as much more secure with unprecedented privacy protection. “All traffic on Skywire is encrypted end-to-end,” said a spokesperson. “The technology we’ve developed makes tracking or spying on users literally impossible. The kinds of privacy violations we’ve seen from Facebook and Google simply couldn’t happen on Skywire.” That’s great news for the increasing number of Internet users who are uncomfortable with the invasive and obscure policies of social media companies, and wish to have greater control over who has access to their private data, and how it is used.</p><p>Skywire technology includes putting the hardware infrastructure for Skywire directly into the hands of its users, which will eventually eliminate the need for Internet Service Providers altogether. Operating a low-power Skyminer is as simple as plugging it into a home Internet router, which users are incentivized to do by earning cryptocurrency just for keeping nodes online. Skywire is designed to be hardware agnostic, meaning that people can buy Skyminers directly from Skycoin, or build their own using inexpensive materials available online. Running a Skyminer is an attractive investment for anyone who wishes to help build the Skywire infrastructure, but is not necessary in order to use the network.</p><p>“When Skyminers are attached to antennas, they can begin to link together into a wireless network that doesn’t require traditional Internet access in order to function, and can be accessed freely by any computer or device that can connect to a WiFi signal,” a spokesperson explained.</p><p>Users will not have to choose between two Internets; Skywire will allow access to the existing Internet for those who want the best of both worlds, though the ultimate in speed, privacy and security can only be found on Skywire.</p><p>The nature of Skywire’s decentralized and distributed infrastructure makes it considerably more robust than the current Internet, which has centralized access points through ISPs.</p><p>Skycoin will roll out a public mainnet for Skywire soon, which will mark the final phase in its launch. The first fully-functional large-scale mesh network running Skywire will debut in New York City before the end of the year, with other major cities around the world coming online in the near future as Skywire continues its ambitious worldwide roll-out.</p><p><strong>Interviews may be scheduled via email</strong>: <a href="mailto:drew@skycoin.com">drew@skycoin.com</a></p><p><strong>About Skycoin</strong></p><p>Skycoin is bringing people what they want: a truly decentralized network without any central authority. Founded in 2011 by early developers of Bitcoin and Ethereum, Skycoin quickly grew into an ecosystem of exciting and ambitious projects, including Skywire, the new decentralized Internet; CX, a revolutionary full-featured blockchain application programming language; and the cryptocurrency itself, Skycoin - simple to use, with virtually-free transactions that execute almost instantly. In 2020, Skycoin will release a superior “web-of-trust” blockchain consensus algorithm called Obelisk, which solves the problems inherent to “proof-of-work” and “proof-of-stake” protocols, both of which are slowing down and compromising the integrity of other major cryptocurrencies. For more background, please visit <a href="https://www.skycoin.com" rel="noopener noreferrer" target="_blank">https://www.skycoin.com</a></p><p><strong>Contact:</strong></p><p>Drew Macgibbon <br><a href="mailto:drew@skycoin.com">drew@skycoin.com</a></p><p><strong>SOURCE:</strong> Skycoin</p>',
      },
    },
    releases_october: {
      title: 'Skycoin Project Releases Hardware Development Kit (HDK) for New Cryptocurrency Wallet',
      description: 'Early Bitcoin and Ethereum Developers Set to Roll-Out "Skywire" - a New, Decentralized Internet from Skycoin',
      dates: 'October 14, 2019',
      content: {
        description: '<p><em>Skycoin is the first cryptocurrency to issue its own hardware wallet, along with a Hardware Development Kit to extend functionality</em></p><p><strong>Shanghai, China / October 14th, 2019 /</strong> The Skycoin Project is pleased to announce the release of a Skywallet Hardware Development Kit (HDK) to anyone interested in extending the functionality of Skywallet, Skycoin’s sleek new hardware cryptocurrency wallet. The HDK is a developer-friendly version of the Skywallet, modified to facilitate programming and testing new code.</p><p>The Skywallet was made to support Skycoin (SKY) and Skycoin Coin Hours (SCH) out of the box, and a future firmware update will enable the Skywallet to hold additional major currencies, including Bitcoin, Ethereum, and more. But with thousands of cryptocurrency coins, tokens, and other assets available for trade, Skycoin wanted to ensure motivated developers had the opportunity to build support into Skywallet for their favourite cryptocurrency.</p><p>The support for additional cryptocurrencies may be accomplished using the HDK and then rolled out to Skywallet users in an optional firmware update, pending approval. The HDK may also be used to create applications that can run on Skywallet. For instance, if a developer wishes to use Skywallet as an authentication device, they could use the HDK to develop that functionality.</p><p>"We made Skywallet the most affordable hardware wallet on the market because we think crypto investors deserve the best security for their investment," said a spokesperson for the project. "We also know there are a lot of cryptocurrencies, and we wanted to give developers the chance to extend the power of Skywallet to their own favourite crypto coin or token."</p><p>The developer-friendly nature of Skywallet extends beyond the Hardware Development Kit to the firmware of the Skywallet itself, which is completely open-source. This means that the security of the Skywallet software may be verified by anyone who wishes to audit the code, because the complete codebase for the firmware is hosted in an open-source repository on <a href="https://github.com/skycoin/hardware-wallet" rel="noopener noreferrer" target="_blank">github</a>.</p><p>More exciting hardware projects from Skycoin, including Skywire antennas and the next generation of Skyminers, will be announced in the coming weeks and months.</p><p>The Skywallet Hardware Development Kit is available to order online at <a href="https://store.skycoin.com/" rel="noopener noreferrer" target="_blank">store.skycoin.com</a> beginning October 14, 2019.</p><p><strong>Media who wish to schedule interviews may reach out to:</strong> <br><strong>Khalob Freeborn</strong> <br><a href="mailto:khalob@skycoin.comm">khalob@skycoin.com</a> <br>+14243542994</p><p> <br></p><hr><p> <br></p><p><strong>About Skycoin:</strong></p><p>Skycoin is bringing people what they want: a truly decentralized network without any central authority. Founded in 2011 by early developers of Bitcoin and Ethereum, Skycoin quickly grew into an ecosystem of exciting and ambitious projects, including <strong>Skywire</strong>, the new decentralized Internet; <strong>CX</strong>, a revolutionary fully-featured blockchain application programming language; and the cryptocurrency itself, <strong>Skycoin</strong> — simple to use, with virtually-free transactions that execute almost instantly.</p><p>In 2020, Skycoin will release a superior "web-of-trust" blockchain consensus algorithm called <strong>Obelisk</strong>, which solves the problems inherent to "proof-of-work" and "proof-of-stake" protocols, both of which are slowing down and compromising the integrity of other major cryptocurrencies.</p><p>For more background, please visit <a href="https://www.skycoin.com" rel="noopener noreferrer" target="_blank">https://www.skycoin.com</a></p>',
      },
    },
    releases_2019_10_18: {
      title: 'Secure and Private “New Internet” Skywire set to Launch in New York City',
      description: 'First Skywire NYC Meetup is a success',
      dates: 'October 18, 2019',
      content: {
        description: '<p><em>First Skywire NYC Meetup is a success</em></p><p><strong>New York City, New York / October 14th, 2019 /</strong> Skycoin held its first Skywire Mainnet Meetup in New York City on Thursday in anticipation of its forthcoming Skywire mesh network. The meeting took place at the NYC Blockchain Center, where Skycoin is a member, and was a great success. The meeting was also live-streamed via YouTube where dozens more watched it live, and several hundred tuned in to watch the final recording.</p><p>Skywire is the Skycoin Project’s new decentralized, private, and end-to-end encrypted internet. It is a mesh network comprised of small antennas attached to nodes called Skyminers. (Skyminers are powerful computers that provide the processing power, storage, and bandwidth for the network.)</p><p>The Skywire network in New York City is being built by members of the Skycoin community who believe in the principles of a free and open Internet, where privacy and security are foundational. Skywire puts the power is firmly in the hands of users, rather than Internet Service Providers, corporations, or advertisers. And unlike other attempts at creating community mesh nets, Skywire is incentivized. This means that Skycoin will pay node operators for their service to the network as a way to encourage growth and adoption of Skywire.</p><p>The ongoing rollout of the New York meshnet across Manhattan is a major milestone and proof-of-concept for the Skycoin Project, which has been working on the “new Internet” for nearly a decade.</p><p>Presenters at the meetup explained the technical details of the Skywire network to attendees, including multi-label packet switching (MPLS), public-key addressing, and software-defined networking, all of which make the Skywire network faster, safer, and more private than the current Internet. A number of antennas were shown as well, including long and short-range antennas. It is these antennas that will allow Skywire nodes to connect to one another across the city, and allow anyone within range to freely join the network.</p><p>The Skywire network will continue to be built over the coming months, growing stronger as more New Yorkers join the effort by deploying Skywire nodes of their own. The nodes themselves are easy to build using readily available parts, or may be purchased directly from skycoin.com.</p><p>Anyone interested in helping out should connect with the New York team via Telegram at t.me/SkycoinNewYork.</p><p><strong>Media who wish to schedule interviews may reach out to:</strong> <br><strong>Khalob Freeborn</strong> <br><a href="mailto:khalob@skycoin.comm">khalob@skycoin.com</a> <br>+14243542994</p><p> <br></p><hr><p> <br></p><p><strong>About Skycoin:</strong></p><p>Skycoin is bringing people what they want: a truly decentralized network without any central authority. Founded in 2011 by early developers of Bitcoin and Ethereum, Skycoin quickly grew into an ecosystem of exciting and ambitious projects, including <strong>Skywire</strong>, the new decentralized Internet; <strong>CX</strong>, a revolutionary fully-featured blockchain application programming language; and the cryptocurrency itself, <strong>Skycoin</strong> — simple to use, with virtually-free transactions that execute almost instantly.</p><p>In 2020, Skycoin will release a superior "web-of-trust" blockchain consensus algorithm called <strong>Obelisk</strong>, which solves the problems inherent to "proof-of-work" and "proof-of-stake" protocols, both of which are slowing down and compromising the integrity of other major cryptocurrencies.</p><p>For more background, please visit <a href="https://www.skycoin.com" rel="noopener noreferrer" target="_blank">https://www.skycoin.com</a></p>',
      },
    },
    releases_2019_11_26: {
      title: 'Skycoin Project Releases Affordable High-Security Hardware Wallet',
      description: 'Skycoin is the first cryptocurrency to issue its own hardware wallet.',
      dates: 'November 26, 2019',
      content: {
        description: '<p><em>Skycoin is the first cryptocurrency to issue its own hardware wallet.</em></p><p><em>Shanghai, China</em> — Skycoin is pleased to announce the immediate availability of <strong><em>Skywallet</em></strong>, a sleek and sophisticated cryptocurrency hardware wallet designed specifically with Skycoin in mind.</p><p>Skywallet was made to support Skycoin (SKY) and Skycoin Coin Hours (SCH) out of the box, and a future firmware update will enable the Skywallet to hold many different coins and tokens, including Bitcoin, Ethereum, and more. In addition, a Hardware Development Kit (HDK) is available to developers who wish to further extend the Skywallet’s functionality.</p><p>Skywallet is initially available in three different colors (black, white, and silver) for just $39.00 USD each. Despite the massive price drop relative to competition, no corners have been cut on ensuring that these devices are secure. In fact, the Skycoin team uncovered and resolved significant flaws in the firmware code of one of the most popular devices currently available.</p><p>“We wanted everyone to have an affordable option for securely protecting their Skycoin investment,” said a spokesperson for the project.</p><p>Unlike mobile or desktop software wallets, the seed phrase (or “private key”) that generates the Skycoin address on the Skywallet is never exposed to a computer or the Internet, and cannot be accessed or hijacked by an attacker.<strong>This means the Skywallet is completely private and secure</strong>, even if one’s personal computer or Internet connection is compromised.</p><p>The security of the Skywallet software may be verified by anyone who wishes to audit the code, because the complete codebase for the firmware is hosted in an open-source repository on <a href="https://github.com/skycoin/hardware-wallet" rel="noopener noreferrer" target="_blank">GitHub</a>.</p><p>The Skycoin team is uniquely qualified to produce Skywallets, as they have nearly a decade of experience building both hardware and software solutions to some of blockchain’s most intractable problems. Skycoin’s existing hardware products include approximately 10,000 Skyminer nodes deployed around the world, forming the telecommunications infrastructure of Skycoin’s new encrypted internet: Skywire.</p><p>More exciting hardware projects, including Skywire antennas and the next generation of Skyminers, will be announced in the coming weeks and months.</p><p>The Skywallet is available to order online at &nbsp; <a href="https://store.skycoin.com/" rel="noopener noreferrer" target="_blank">store.skycoin.com</a> beginning November 28, 2019.</p><p>Media who wish to schedule interviews may reach out to:&nbsp;</p><p>Tiffany</p><p> <a href="mailto:mktcn@skycoin.com">mktcn@skycoin.com</a></p><p>0085263533831</p><p> <br></p><hr><p> <br></p><p><strong>About Skycoin:</strong></p><p>Skycoin is bringing people what they want: a truly decentralized network without any central authority. Founded in 2011 by early developers of Bitcoin and Ethereum, Skycoin quickly grew into an ecosystem of exciting and ambitious projects, including <strong>Skywire</strong>, the new decentralized Internet; <strong>CX</strong>, a revolutionary fully-featured blockchain application programming language; and the cryptocurrency itself, <strong>Skycoin</strong> — simple to use, with virtually-free transactions that execute almost instantly.</p><p>In 2020, Skycoin will release a superior "web-of-trust" blockchain consensus algorithm called <strong>Obelisk</strong>, which solves the problems inherent to "proof-of-work" and "proof-of-stake" protocols, both of which are slowing down and compromising the integrity of other major cryptocurrencies.</p><p>For more background, please visit <a href="https://www.skycoin.com" rel="noopener noreferrer" target="_blank">https://www.skycoin.com</a></p>',
      },
    },
  },
  sky_wallet: {
    title: 'Skywallet - Skycoin`s New Hardware Wallet',
    description: 'Skywallet - New Hardware Wallet',
    hero: {
      heading: 'Skywallet: <br/>Hardware for the new internet.',
    },
    about: {
      heading: 'Skywallet',
      subheading: 'Skycoin`s New Hardware Wallet',
      paragraph: 'When you store or access your cryptocurrency, you are your own bank, so the process should be simple and intuitive. Your hardware wallet is your bank vault and it should feel like a premium and secure device. We’ve spent months iterating over designs and incorporating user feedback in order to make Skywallet the best hardware wallet experience on the market.',
    },
    features: {
      heading: 'Getting started',
      recoveryseed: {
        title: 'Recovery seed',
        text:
          'The recovery seed is a backup for your entire device. If your device is lost or damaged, you can recover your wallets using the seed phrase. It is generated on your device and only shown once. It should go without saying that if somebody finds your seed, they can easily clone your device. Do not store the seed or communicate it digitally. Support will never ask for your seed.',
      },
      instructions: {
        title: 'Quick Start Guide',
        text:
          '<ol> <li>Check the package of your Skywallet for any signs of tampering. Unpack the Skywallet if the packaging is intact.</li><li>Download the latest version of the Desktop Wallet and the Skywallet Daemon below.</li><li>If you are using a Mac, install the daemon. It will automatically run in the background afterwards. If you are using Windows, run the daemon everytime you want to connect to the Skywallet.</li><li>Connect the Skywallet to your computer and follow the instructions in the Desktop Wallet.</li></ol>',
      },
      treatment: {
        title: 'Treatment',
        text:
          'Do not expose the Skywallet to extreme temperatures or elements. It is not waterproof, heat or acid resistant.',
      },
      download: {
        title: 'Download',
        text:
          '<p>Download the Skywallet user manual here:</p><p> <a href="https://s3-ap-southeast-1.amazonaws.com/downloads.skycoin.com/skywallet/Skywallet-User_Manuals_Draft_1_c.pdf" rel="noopener noreferrer" target="_blank">User Manual</a></p><p>Download the Desktop Wallet and the Skywallet Daemon here:</p><p> <a href="/downloads/">https://skycoin.com/downloads/</a></p>',
      },
    },
  },
  skywallethdk: {
    title: 'Skywallet HDK',
    description: 'Skywallet HDK - Make your favourite token compatible with Skywallet',
    about: {
      heading: 'Skywallet HDK',
      subheading: 'Make your favourite token compatible with Skywallet',
      paragraph: '<p>The Skywallet HDK (Hardware Development Kit) is the developer-friendly version of the Skywallet hardware that is intended to make it easy to create applications, or integrate other cryptocurrencies and tokens into the Skywallet.</p><p>There are several key differences between the Skywallet and the Skywallet HDK that make the HDK easier to use for developers. The Skywallet HDK:</p><ul> <li>Does not have a case around the circuit board</li><li>Is physically bigger than the small, sleek consumer-facing Skywallet</li><li>Features larger buttons that are easier to work with</li><li>Has a 6-pin socket for ST programmer</li><li>Does not have a pre-flashed bootloader</li></ul><p>The primary use of the Skywallet HDK is to build capability into Skywallet to support cryptocurrencies beyond Skycoin and Skycoin Coin Hours. The HDK may also be used to create additional programs that may run on Skywallet. If a developer wishes to use Skywallet as an authentication device, for instance, they can use the HDK to develop that functionality.</p><p>All new programs and token compatibilities which are developed on the Skywallet HDK can be submitted to Skycoin for review. If approved, your update will be pushed out to all current Skywallet holders who can opt-in to the new functionality.</p><p>If you would like to extend the functionality and capability of Skywallet for all its users, grab a Skywallet HDK and get coding!</p>',
    },
    features: {
      heading: 'Getting started',
      instructions: {
        title: 'Instructions',
        text: '<p>Join the Telegram room <a href="https://t.me/SkycoinDevelopers" rel="noopener noreferrer" target="_blank">&commat;SkycoinDevelopers</a> or file an issue on Github if you want to get in touch with the development team.</p>',
      },
      treatment: {
        title: 'Treatment',
        text:
          'Do not expose the Skywallet to extreme temperatures or elements. It is not waterproof, heat or acid resistant.',
      },
      download: {
        title: 'Download',
        text:
          '<ul> <li> <a href="https://github.com/skycoin/hardware-wallet" rel="noreferrer nofollow" target="_blank">https://github.com/skycoin/hardware-wallet</a> </li><li> <a href="https://github.com/skycoin/hardware-wallet-daemon" rel="noreferrer nofollow" target="_blank">https://github.com/skycoin/hardware-wallet-daemon</a> </li><li> <a href="https://github.com/skycoin/hardware-wallet-go" rel="noreferrer nofollow" target="_blank">https://github.com/skycoin/hardware-wallet-go</a> </li></ul>',
      },
      documentation: {
        title: 'Documentation and codebase',
        text:
          '<ul><li> <a href="https://github.com/skycoin/hardware-wallet" rel="noopener noreferrer" target="_blank">https://github.com/skycoin/hardware-wallet</a> </li><li> <a href="https://github.com/skycoin/hardware-wallet-daemon" rel="noopener noreferrer" target="_blank">https://github.com/skycoin/hardware-wallet-daemon</a> </li><li> <a href="https://github.com/skycoin/hardware-wallet-go" rel="noopener noreferrer" target="_blank">https://github.com/skycoin/hardware-wallet-go</a> </li></ul>',
      },
    },
    gallery: {
      title: 'Gallery',
      description: 'Gallery',
      heading: 'Gallery',
      skywallethdk: {
        heading: 'Gallery',
      },
    },
  },
  cxs: {
    cx: {
      title: 'CX',
      header: {
        title: 'From Smart Contracts to Machine Learning and Video Games',
        desc: 'CX is Skycoin’s feature-rich programming language. It is designed to address the growing needs of Skycoin’s ambitious ecosystem of projects that can’t be satisfied with any other available languages.',
      },
      hero: {
        title: 'CX Book Released',
        desc: 'If you’re a programmer or student and want to learn more about CX, you can get your hands on our newly released book series. The first book introduces the basics of the language and future books will teach you how to program with CX for video games and smart contracts.',
        link: 'Read it here',
      },
      button: 'install cx',
    },
    docs: {
      title: 'docs',
    },
    example: {
      title: 'example',
    },
    about: {
      title: 'about',
    },
    github: {
      title: 'github',
    },
  },
  cxchains: {
    title: 'CX Chains Overview',
    description: '',
  },
  cookiesAlert: {
    title: 'This site uses cookies',
    content1: 'By clicking "Accept", you agree this website can store cookies on your device and disclose information in accordance with our',
    content2: 'Cookie Policy.',
    button: 'Accept',
  },
  cookiesTerms: {
    title: 'Cookie Policy',
    content: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer tortor est, posuere et ultricies nec, tincidunt at magna. Nullam consectetur ac nisi hendrerit interdum. Nam consequat, sem eget ullamcorper vestibulum, tellus arcu consectetur felis, sed bibendum ante dui quis tortor. In volutpat orci a purus blandit porttitor. Aliquam erat volutpat. Nullam commodo nisi quis lectus venenatis, id consectetur purus molestie. Maecenas suscipit, augue a volutpat consectetur, turpis velit consequat ex, a vehicula enim ligula vel purus. Praesent vel dolor dolor. Nulla id neque id enim bibendum porttitor sit amet quis quam.',
  },
};

/* eslint-enable max-len */



// WEBPACK FOOTER //
// ./src/locales/en.js